import React from "react";

import {
    Box,
    Button
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

export interface criticalActionConfirmDialogProps {
    props: {
        open: boolean,
        onCancel: any,
        onExecution: any,
        body: string,
        confirmCancel: string,
        confirmOk: string,
    }
}

const CriticalActionConfirmDialog: React.FC<criticalActionConfirmDialogProps> = ({ props }) => {
    const [open, setOpen] = React.useState(false);
    const [isOkButtonDisabled, setIsOkButtonDisabled] = React.useState(true);
    const [progress, setProgress] = React.useState(0);

    const handleClose = () => {
        setOpen(false);
        props.onCancel();
        setIsOkButtonDisabled(true);
        setProgress(0);
    };

    const handleOk = () => {
        setOpen(false);
        props.onExecution();
        setIsOkButtonDisabled(true);
        setProgress(0);
    };

    React.useEffect(() => {
        if (props.open) {
            setOpen(props.open);
            setProgress(0);
            
            // 進捗アニメーション用のインターバル
            const progressInterval = setInterval(() => {
                setProgress(prev => {
                    const newProgress = prev + (100 / 60); // 3秒間で60回更新（50msごと）
                    if (newProgress >= 100) {
                        clearInterval(progressInterval);
                        return 100;
                    }
                    return newProgress;
                });
            }, 50);
            
            // 3秒後にOKボタンを活性化
            const timer = setTimeout(() => {
                setIsOkButtonDisabled(false);
                setProgress(100);
            }, 3000);

            // クリーンアップ関数でタイマーをクリア
            return () => {
                clearTimeout(timer);
                clearInterval(progressInterval);
            };
        }
    }, [props.open]);

    return (
        <Box>
            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <Box sx={{ padding: '20px' }}>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description" sx={{ whiteSpace: 'pre-wrap', color: '#000000' }}>
                        {props.body}
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: 'space-around' }}>
                        <Button variant="outlined" color="error" onClick={handleClose}>{props.confirmCancel}</Button>
                        <Button 
                            variant="contained" 
                            onClick={handleOk} 
                            disabled={isOkButtonDisabled}
                            sx={{
                                background: isOkButtonDisabled 
                                    ? `linear-gradient(to right, red ${progress}%, #e0e0e0 ${progress}%)`
                                    : 'red',
                                color: 'white',
                                '&:hover': {
                                    background: isOkButtonDisabled 
                                        ? `linear-gradient(to right, red ${progress}%, #d0d0d0 ${progress}%)`
                                        : 'red',
                                },
                                '&.Mui-disabled': {
                                    color: 'white',
                                    background: `linear-gradient(to right, red ${progress}%, #e0e0e0 ${progress}%)`,
                                },
                                transition: 'none',
                            }}
                        >
                            {props.confirmOk}
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </Box>
    );

}

export default CriticalActionConfirmDialog;
